exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".__panel-simple[data-v-fa41e642]{position:absolute;z-index:99999;bottom:0;width:100%;padding:0 15px}.__panel-simple__panel[data-v-fa41e642]{background-color:#fff;border:2px solid #6e6bce;border-radius:3px}.__panel-simple__close[data-v-fa41e642]{right:15px;top:15px;position:absolute}.__panel-simple__inner[data-v-fa41e642]{width:100%;height:100%;padding:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fa41e642","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/panel/Simple.vue
// module id = 25065d703aaf8356a353
// module chunks = 0